export const GET_LEAD_PROFILE_PHOTOS_REQUEST = 'GET_LEAD_PROFILE_PHOTOS_REQUEST';
export const GET_LEAD_PROFILE_PHOTOS_REQUEST_SUCCESS = 'GET_LEAD_PROFILE_PHOTOS_REQUEST_SUCCESS';
export const GET_LEAD_PROFILE_PHOTOS_REQUEST_FAILURE = 'GET_LEAD_PROFILE_PHOTOS_REQUEST_FAILURE';

export const UPLOAD_LEAD_PROFILE_PHOTO_REQUEST = 'UPLOAD_LEAD_PROFILE_PHOTO_REQUEST';
export const UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS = 'UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS';
export const UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_FAILURE = 'UPLOAD_LEAD_PROFILE_PHOTO_REQUEST_FAILURE';

export const DELETE_LEAD_PROFILE_PHOTO_REQUEST = 'DELETE_LEAD_PROFILE_PHOTO_REQUEST';
export const DELETE_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS = 'DELETE_LEAD_PROFILE_PHOTO_REQUEST_SUCCESS';
export const DELETE_LEAD_PROFILE_PHOTO_REQUEST_FAILURE = 'DELETE_LEAD_PROFILE_PHOTO_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/lead_profile_photos.constants.js